export default __webpack_public_path__ + "static/media/16.ff0dd677.jpg";